import React from "react";
import { FooterTitle, FooterTitleTextWrapper,FooterTitleLine } from "./FooterTitleTextStyled";

const FooterTitleText = (props) => {
  return (
    <FooterTitleTextWrapper>
      <FooterTitle>{props.title}</FooterTitle>
      <FooterTitleLine/>
    </FooterTitleTextWrapper>
  );
};

export default FooterTitleText;
